import { useMutation } from "@tanstack/react-query";
import { resetPassword } from "../../services/apiAuth";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export function useResetPassword() {
  const navigate = useNavigate();

  const { mutate: reset, isPending: isResetting } = useMutation({
    mutationFn: ({ token, password }) => resetPassword({ token, password }),
    onSuccess: () => {
      toast.success("Password reset successfully.");
      navigate("/login", { replace: true });
    },
    onError: (err) => toast.error(err.message),
  });
  return { reset, isResetting };
}
